module.exports = __webpack_public_path__ + "img/galeria-pets-2.b80958c6.jpg";